import { connect } from 'react-redux'

import { classMap } from 'utils'

import actions from 'actions'

const actionMap = (types = []) => types.reduce((acc, t) => ({ ...acc, [t]: actions[t] }), {})
const stateMap = (states = []) => ({ ...states }) => ({ ...states })

export default (component, states = [], actions = []) =>
  connect(stateMap(states), actionMap(actions))(classMap(component))
